<template>
  <div class="container">
      <main>
            <Search @getInputValue='getInputValue' @search='search' @add='add'>还款记录</Search>
            <el-table
                :data="list"
                header-align="center"
                :row-class-name="TableRowClassName"
                style="width:100%;padding:0 0px;height:100%"
                :header-cell-style="{ background: '#EBEEF8',height: '45px' }"
                :cell-style="{padding:'0px'}"
            >
            <el-table-column
            label="序号"
            type="index"
            :index="indexMethod"
            align="center"
            >
            </el-table-column>
            <el-table-column
            prop="customerName"
            label="客户名称"
            align="center"
            show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
            prop="factorNo"
            label="设备编号"
            align="center"
            show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
            prop="startDate"
            label="按揭开始日期"
            align="center"
            show-overflow-tooltip
            >
            <template slot-scope="scope">
                <span>{{scope.row.startDate |timeFomart}}</span>
            </template>
            </el-table-column>
            <el-table-column
            prop="periodsNum"
            label="分期数"
            align="center"
            show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
            prop="repaymentDate"
            label="应还日期"
            align="center"
            show-overflow-tooltip
            >
            <template slot-scope="scope">
                <span>{{scope.row.repaymentDate |timeFomart}}</span>
            </template>
            </el-table-column>
            <el-table-column
            prop="status"
            label="还款状态"
            align="center"
            show-overflow-tooltip
            >
            <template slot-scope="scope">
                <span :style="{color:scope.row.color}">{{scope.row.status}}</span>
            </template>
            </el-table-column>
            <el-table-column
            prop="realRepaymentDate"
            label="还款日期"
            align="center"
            show-overflow-tooltip
            >
            <template slot-scope="scope">
                <span>{{scope.row.realRepaymentDate |timeFomart}}</span>
            </template>
            </el-table-column>
            <el-table-column
            prop="remark"
            label="备注"
            align="center"
            show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
            label="操作"
            align="center"
            fixed="right"
            min-width="80"
            width="80"
            >
                <template slot-scope="scope">
                    <div style="display:flex;width:100%;justify-content:space-around">
                        <el-button @click="edit(scope.row)" type="text" size="mini" class="btn">
                            <i class="el-icon-view" style="fontSize:19px"></i>
                        </el-button>
                    </div>
                </template>
            </el-table-column>
            </el-table>
            <Pagination :pageTotal="pageTotal" @currentPage="currentPage"/>
        </main>
        <el-dialog :title="isEdit?'编辑':'新增'"  :visible.sync="dialogFormVisible" center :close-on-click-modal="false" style="width:60%;margin:0 auto;marginTop:-50px">
            <div class="dialogline"></div>
                <el-form :model="dialogForm" class="dialogForm" :rules="formRules" ref="formRules">
                    <el-form-item label="客户名称" label-width="100px" prop="customerName">
                        <el-input disabled v-model="dialogForm.customerName" autocomplete="off" placeholder="请输入银行流水" ></el-input>
                    </el-form-item>
                    <el-form-item label="设备编号" label-width="100px" prop="factorNo">
                        <el-input disabled v-model="dialogForm.factorNo" autocomplete="off" placeholder="请输入银行流水" ></el-input>
                    </el-form-item>
                    <el-form-item label="按揭开始" label-width="100px" prop="startDate">
                        <el-date-picker
                            disabled
                            style="width:100%"
                            v-model="dialogForm.startDate"
                            type="date"
                            @change="selectValue"
                            placeholder="请选择按揭开始日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="应还日期" label-width="100px" prop="repaymentDate">
                        <el-date-picker
                            disabled
                            style="width:100%"
                            v-model="dialogForm.repaymentDate"
                            type="date"
                            @change="selectValue"
                            placeholder="请选择应还日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="分期数目" label-width="100px" prop="periodsNum">
                        <el-input disabled v-model="dialogForm.periodsNum" autocomplete="off" placeholder="请输入银行流水" ></el-input>
                    </el-form-item>
                    <el-form-item label="还款状态" label-width="100px" prop="status">
                        <el-input disabled v-model="dialogForm.status" autocomplete="off" placeholder="请输入银行流水" ></el-input>
                    </el-form-item>
                    <el-form-item label="还款日期" label-width="100px" prop="realRepaymentDate">
                        <el-date-picker
                            disabled
                            style="width:100%"
                            v-model="dialogForm.realRepaymentDate"
                            type="date"
                            @change="selectValue"
                            placeholder="请选择还款日期">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="备注信息" label-width="100px" prop="remark" >
                        <el-input disabled type="textarea" :rows="3" v-model="dialogForm.remark" autocomplete="off" placeholder="添加备注信息" ></el-input>
                    </el-form-item>
                </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">确 定</el-button>
            </div>
        </el-dialog>
  </div>
</template>

<script>
import '../assets/js/timeFomart'
export default {
    data(){
        return{
            option: {
                filter: '',
                pageSize: 15,
                pageIndex: 1
            },
            dialogForm: {
                customerName:'',
                factorNo:'',
                startDate:'',
                periodsNum:'',
                repaymentDate:'',
                status:'',
                realRepaymentDate:'',
                remark:'',
            },
            formRules:{
                model:[{
                    required: true,
                    message: "请输入规格型号",
                    trigger: "blur"
                }],
            },
            pageTotal: 1,
            isEdit: false,
            dialogFormVisible: false,
            list: [],
            inputValue: '',
        }
    },
    methods:{
        //获取list
        getList(option){
            this.$api.PaymentList(option).then(res=>{
                this.list = res.data.data.data;
                this.pageTotal = res.data.data.total;
                this.statusFormart(this.list);
            })
        },
        //获取页码
        currentPage(option){
            this.option.pageIndex = option
            this.getList(this.option);
        },
        //处理还款状态函数
        statusFormart(option){
            if(option.length==0) return;
            option.map((item,i)=>{
                switch (item.status) {
                    case 0:
                        item.color = '#AD454E'
                        item.status = '未还款'
                        break;
                    case 1:
                        item.color = '#AD454E'
                        item.status = '已超期'
                        break;
                    case 2:
                        item.color = '#EDB941'
                        item.status = '超期还款'
                        break;
                    case 3:
                        item.color = '#6D9E7B'
                        item.status = '已还款'
                        break;
                }
            })
        },
        //选择还款日期
        selectValue(){
            this.dialogForm.productDate = this.dialogForm.productDate.format("yyyy-MM-dd") + ' ' + '00:00:00';
        },
        //表格前编号
        indexMethod(index) {
            return index+1 ;
        },
        //表格隔行变色，样式在app.vue里
        TableRowClassName({row,rowIndex}){
            if(rowIndex%2 != 0){
                return 'backtablegray'
            }else{
                return 'backtablewhite'
            }
        },
        //获取搜索框值
        getInputValue(option){
            this.inputValue = option;
            this.option.filter = option;
        },
        //搜索按钮
        search(){
            this.getList({
                filter: this.inputValue,
                pageSize: 15,
                pageIndex: 1
            });
        },
        //添加按钮
        add(){
            this.isEdit = false;
            this.dialogFormVisible = true;
            this.dialogForm = {
                id: 0,
                name: '',
                shortName: '',
                linker: '',
                linkerTel: '',
                remark: ''
            };
        },
        //编辑按钮
        edit(row) {
            this.isEdit = true;
            this.dialogFormVisible = true;
            this.dialogForm = {
                customerName: row.customerName,
                factorNo: row.factorNo,
                startDate: row.startDate,
                periodsNum: row.periodsNum,
                repaymentDate: row.repaymentDate,
                status: row.status,
                realRepaymentDate: row.realRepaymentDate,
                remark: row.remark,
            };
        },
    },
    mounted(){
        this.getList(this.option);
    }
}
</script>

<style lang='scss' scoped>
.container{
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
}
main{
    overflow: hidden;
    background: #fff;
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 0 8px;
}
</style>